import { occurrences } from './occurrences';
export var sortByMatchesInAnswer = function (faqItems, query) {
    if (query === void 0) { query = ''; }
    var loweredQuery = query.toLowerCase();
    return faqItems.sort(function (x, y) {
        var matchesInX = occurrences(x.answer || '', loweredQuery);
        var matchesInY = occurrences(y.answer || '', loweredQuery);
        if (matchesInX > matchesInY) {
            return -1;
        }
        if (matchesInX < matchesInY) {
            return 1;
        }
        return 0;
    });
};
